module.exports = __webpack_public_path__ + "images/category_lp/camera/Leica-Q(Typ116)_bc55c0e382f9d005949c8e2f0c3d38ca.png";